import React, { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns-tz';
import getUnixTime from 'date-fns/getUnixTime';
import { Alert, Button, Table, Loader } from '@itds/elements/index.js';

import EditDrawer from './agency_forms/Edit';

import { Api } from '@brokerage/utils/Api';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';

const AgencyFormsList = () => {
  const { agency } = useContext(AgencyContext);
  const [agency_forms, setAgencyForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(null);
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();

  const new_form = {
    agency_guid: agency.guid,
    form_name: '',
    description: '',
    pdf_file: null,
    product_guids: [],
    form_tag_ids: []
  };

  useEffect(() => {
    if (agency && agency.guid) {
      loadAgencyForms();
    }
  }, [agency]);

  const loadAgencyForms = () => {
    setLoading(true);

    Api.loadAgencyForms(agency.guid).then(({ data }) => {
      setAgencyForms(data);
      setLoading(false);
    });
  };

  const handleSave = response => {
    loadAgencyForms();

    setTimeout(() => {
      setErrorMessage(null);
      setSuccessMessage(null);
    }, 2000);

    return response === 'success'
      ? setSuccessMessage('Agency Form updated successfully')
      : setErrorMessage('Unable to update Agency Form');
  };

  const handleDelete = (guid, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);

    setLoading(true);

    Api.deleteAgencyForm(guid).then(() => {
      loadAgencyForms();
      setLoading(false);
    });
  };

  return (
    <>
      <EditDrawer
        agency={agency}
        form={form}
        onClose={setForm.bind(null, null)}
        onSave={handleSave}
        show={!!form}
      />

      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <div style={{ display: 'flex', marginBottom: 30, justifyContent: 'flex-end' }}>
        <Button onClick={setForm.bind(null, { ...new_form })}>New Agency Form</Button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Table
          columns={[
            {
              id: 'form_name',
              is_sortable: true,
              label: 'Name'
            },
            {
              id: 'guid',
              label: 'Guid'
            },
            {
              id: 'created_at',
              is_sortable: true,
              label: 'Created On',
              render: form => format(new Date(form.created_at), 'MMM do, yyyy @ h:mm aaa z'),
              sort_by: form => getUnixTime(new Date(form.created_at))
            },
            {
              id: 'actions',
              render: form => {
                return (
                  <Button
                    color='RED'
                    inline={true}
                    onClick={handleDelete.bind(null, form.guid)}
                    small={true}
                  >
                    Delete
                  </Button>
                );
              },
              styles: { textAlign: 'right' }
            }
          ]}
          data={agency_forms}
          defaultSortColumn={{ id: 'form_name' }}
          onRowClick={form => setForm(form)}
          placeholder="This agency doesn't have any Forms"
        />
      )}
    </>
  );
};

export default AgencyFormsList;
